import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Table } from "react-bootstrap";
import StarRatings from "react-star-ratings";
import { Sidebar } from "../sidebar/Sidebar";
import Navbar from "../navbar/navbar";
import { getReviews, deleteReview,editReview } from "../../../Services/reviews.service";
import { getBusiness } from "../../../Services/business.service";
import { fs,db } from "../../../Services/firebase"
import ConfirmationModal from "../../shared/confirmationModal/confirmationModal";
import _ from "lodash";
// import {getReviews} from '../../../Services/business.service'
export const AdminReviews = () => {
  const [userReviews, setuserReviews] = useState();
  const changeReviewStatus=(data,type)=>{
    
    switch (type) {
    case 0:
      data.status=false;
      console.log(data);
      editReview(data).then((res)=>{console.log('Response getting back after change in status ',res)});
      
      break;
      case 1:
        data.status=true;
        console.log(data);
        editReview(data).then((res)=>{console.log('Response getting back after change in status ',res)});
    
      break;
    default:
      break;
    }

    // console.log('Approved review id is : ',data.reviewId);
  }
  useEffect(() => {
    let filterReviews = [];
    getReviews().then((ress) => {
      getBusiness().then((res) => {
        console.log("review responses are ", ress);
        console.log("business responses are ", res);
        for (let i = 0; i < res.length; i++) {
          for (let j = 0; j < ress.length; j++) {
            if (res[i].businessId === ress[j].itemId) {
               let test ={ reviewId:ress[j].businessId,name:res[i].name,review:ress[j].discripton,status:false,rating:ress[j].myRating};
               filterReviews.push(test);
            }
          }
        }
        console.log("Fliter reviews are : ", filterReviews);
        setuserReviews(filterReviews);
      });
    });
  }, []);
  const approvedReview =()=>{

  }
  return (
    <>
      {/* Page Wrapper */}
      <div id="wrapper">
        {/* Sidebar */}
        <Sidebar />
        {/* End of Sidebar */}
        {/* Content Wrapper */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/* Main Content */}
          <div id="content">
            <Navbar setValue={''} />

            {/* Begin Page Content */}
            <div className="container-fluid">
              {/* Content Row */}
              <div className="row">
                <div className="col">
                  <h2 className="theme-color">All Reviews</h2>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <Table
                    responsive
                    striped
                    bordered
                    hover
                    className="bg-white dashboardTable"
                  >
                    <thead>
                      <tr>
                        <th>Business Name</th>
                        <th>Review</th>
                        <th>Status</th>
                        <th>Ratings</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                    {
                      userReviews&&userReviews.map((item,index)=>
                               <tr key={index}>
                               <td>{item.name}</td>
                               <td>{item.review}</td>
                               <td className="d-flex flex-column">
                                <button className="btn btn-success fs-6 " onClick={()=>{changeReviewStatus(item,1)}}>Approved</button>
                                <button className="btn btn-danger fs-5 mt-2" onClick={()=>{changeReviewStatus(item,0)}}>Unapproved</button>
                               {/* <div className="reviewActionDeleteButton buttonCommon">
                                Approved
                               </div>
                               <div className="buttonCommon btn-success reviewDetailActionButotn">
                                   Not Approved
                                 </div> */}
                               </td>
                               
                               <td>
                                 <div className="w-mc">
                                   <StarRatings
                                     rating={item.rating}
                                     starDimension="18px"
                                     starSpacing="1px"
                                     numberOfStars={5}
                                     starRatedColor="orange"
                                   />
                                 </div>
                               </td>
                               <td className="actionButtonReview">
                                 <div className="reviewActionDeleteButton buttonCommon">Delete</div>
                                 
                                 <div className="buttonCommon btn-success reviewDetailActionButotn">
                                  
                                   <NavLink to={{
                                     pathname: "/admin/reveiw-detail",
                                     businessData: item
                                   }} className="color-white">Detail</NavLink>
                                 </div>
                               </td>
                             </tr>

                      )
                    }
                    
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            {/* /.container-fluid */}
          </div>
          {/* End of Main Content */}
        </div>
        {/* End of Content Wrapper */}
      </div>
      {/* End of Page Wrapper */}

    </>
  );
};